import React, { useEffect, useRef } from "react";

import classes from './Chat.module.css';

const Chat = (props) => {
    let chats = null;
    const messageEndRef = useRef(null);

    useEffect(() => {
        messageEndRef.current.scrollIntoView();
    }, [props.chat]);

    if (props.chat) {
        chats = props.chat.chat_messages.map(chat => {
            console.log(new Date(chat.created_at).toString().slice(4, 21), new Date(chat.created_at).toString().slice(4, 21), new Date())
            return (
                <div ref={messageEndRef}
                    className={classes.ChatRow}
                    key={chat.id}>
                    {chat.receiver_id === +props.reciverId ?
                        <div className={classes.Reciver}>
                            <p>{chat.message}</p>
                            {chat.lightRight ? <div className={classes.LightRight}></div> : null}
                            <small>
                                {new Date(chat.created_at).toString().slice(4, 21)}
                                {chat.read_at ? '  ,Seen' : null}
                            </small>
                        </div>
                        :
                        <div className={classes.Sender}>
                            <p>{chat.message}</p>
                            <small>{new Date(chat.created_at).toString().slice(4, 21)}</small>
                        </div>
                    }
                </div>
            );
        });
    }

    return (
        <div className={classes.Container}>
            {chats}
        </div>
    );
};

export default Chat;